import {ILease, ILeaseChangeEvent} from "./PA.UtilsIF";
import {LeaseRegistry} from "./LeaseRegistry";
import * as _ from 'lodash';
import {BehaviorSubject} from "rxjs";


export class GenericLease
    implements ILease {

    private readonly typeName: string;
    private readonly sClasses: string[];
    private readonly dctClasses: {[className: string] : string};
    private bisDataExpired: boolean = false;
    private onLeaseChange: BehaviorSubject<ILeaseChangeEvent>

    constructor(typeName: string) {
        this.sClasses = [];
        this.dctClasses = {};
        this.typeName = typeName;
        this.addClass(typeName);
        this.addClass(LeaseRegistry.Lease_Class_All);
        this.onLeaseChange = new BehaviorSubject<ILeaseChangeEvent>(undefined)
        LeaseRegistry.registerILease(this);
    }

    getTypeName(): string {
        return this.typeName;
    }

    forceExpire() {
        this.bisDataExpired = true;
        this.OnLeaseChange.next({Lease: this, Change: "Expired"})
    }

    resetLease() {
        this.bisDataExpired = false;
    }

    hasDataChanged(): Promise<boolean> {
        const self = this;
        return new Promise<boolean>((resolve, error) => {
            resolve(self.bisDataExpired);
        });
    }

    getParentClasses(): string[] {
        return this.sClasses;
    }

    addClass(className: string) {
        this.sClasses.push(className);
        this.dctClasses[className] = className;
    }
    
    addClasses(classNames: string[]): void {
        const self = this;
        _.forEach(classNames, (aClass) => {
            self.addClass(aClass);
        });
    }

    hasClass(className: string): boolean {
        return !_.isUndefined(this.dctClasses[className]);
    }

    get OnLeaseChange(): BehaviorSubject<ILeaseChangeEvent> { return this.onLeaseChange }



}
